import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useCancelInvitation = (): UseMutationResult<
  void,
  unknown,
  { personId: string }
> => {
  const queryClient = useQueryClient();
  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  const cancelInvitation = async ({ personId }: { personId: string }) => {
    await treasureApi().delete(`/users/invitations/${personId}`);
  };

  return useMutation(cancelInvitation, {
    onSuccess: () => {
      queryClient.refetchQueries(ReactQueryKeys.BusinessMembers);
    },
  });
};
